/** @jsx h */
import { h } from 'preact'

import Details from '../Details'
import ExternalLink from '../ExternalLink'
import IconDown from '../../../../assets/images/svgs/icon-chevron-down.svg'
import UserProfile from '../UserProfile'
import ProofPointStatus from '../ProofPointStatus'
import t from '../../../utils/translate'

/* This component handles displaying the Proof Point verification
 * status (evidenced or verified).
 *
 * In uiVersion: V2, it replaces:
 *  - VerifierSection.jsx
 *  - EvidenceSection.jsx
 *  - BlockchainProof.jsx
 *
 * TODO: needs more work to support:
 *  - Verified status
 *  - The 'withEvidenceFromActivity' variation of the Evidenced status
*/
const VerificationSection = ({ activities, analyticsContext, description, issuer, label, url, claimStatus }) =>
  <section class='ModalCard-section'>
    <header class='grid grid-cols-2'>
      <h3 class='ModalCard-heading | flex items-center'>
        <ProofPointStatus
          status={claimStatus}
          evidencedText={t('proof_points.js.evidence.see_evidence')}
          verifiedText={t('proof_points.js.evidence.see_verification')}
        />
      </h3>
      <ExternalLink href={url} className='text-right' linkName='View evidence' analyticsContext={analyticsContext}>
        {t('proof_points.js.evidence.view')}
      </ExternalLink>
    </header>

    <Details
      className='Details--plain | u-marginTop8'
      analyticsName='evidenceDetails'
      analyticsContext={analyticsContext}
    >
      <summary class='BodyUI--regular | flex items-center'>
        {issuer &&
          <UserProfile {...issuer} reversedColumns citation={t('proof_points.js.evidence.provided_by')} />}

        <IconDown class='chevron' aria-hidden />
      </summary>

      <p title={label} class='ModalCard-para u-marginTop8'>
        {description}
      </p>

      {activities &&
        <ul class='ModalCard-list'>
          {activities.map((item, idx) =>
            <li class='ModalCard-listItem' key={`activity-${idx}`}>{JSON.stringify(item)}</li>
          )}
        </ul>}
    </Details>
  </section>

export default VerificationSection
